import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

type AiNoActiveApiKeyAlertProps = {
  show: boolean;
  onClose: () => void;
};

const AiNoActiveApiKeyAlert = ({ show, onClose }: AiNoActiveApiKeyAlertProps) => {
  if (!show) return null;

  return (
    <Alert
      variant="danger"
      className="mb-3 fs--1"
      dismissible
      onClose={onClose}
    >
      <div>
        کلید API شخصی ثبت نشده یا هیچ کلید فعالی ندارید. برای ثبت یا فعال‌سازی کلید
        به{' '}
        <Link to="/settings/ai" className="alert-link">
          تنظیمات AI
        </Link>{' '}
        بروید.
      </div>
      <div className="mt-1">
        همچنین می‌توانید با انتخاب «AI خودکار (کیف پول)» در{' '}
        <Link to="/settings/ai" className="alert-link">
          تنظیمات AI
        </Link>
        ، از اعتبار کیف پول AI برای ارسال درخواست استفاده کنید.
      </div>
    </Alert>
  );
};

export default AiNoActiveApiKeyAlert;
